import { AnyGeoEvent } from 'features/geoEvents/anyGeoEvent.types';
import {
  isFloodingGeoEvent,
  isHazardGeoEvent,
  isLocationGeoEvent,
} from 'features/geoEvents/geoEvent.utils';
import { PermissionData } from 'state/useAuthState';

export const getHasEditRole = (
  geoEvent: AnyGeoEvent,
  permissions: PermissionData,
): boolean => {
  if (isFloodingGeoEvent(geoEvent)) {
    return permissions.canReportFlooding && !permissions.isRxOnlyReporter;
  }
  if (isHazardGeoEvent(geoEvent)) {
    return permissions.canReportHazard;
  }
  if (isLocationGeoEvent(geoEvent)) {
    return permissions.canCreateLocation;
  }
  if (permissions.isRxOnlyReporter) {
    return geoEvent.data.isPrescribed;
  }
  return permissions.canReportWildfire;
};
